// Generated by Melange

import FooterModuleCss from "./footer.module.css";
import * as ReactSimpleIcons from "@icons-pack/react-simple-icons";
import * as ReactRouter from "@tanstack/react-router";
import * as Curry from "melange.js/curry.jsx";
import * as Router__Link from "../router/link.jsx";
import * as Shared__Container from "./container.jsx";
import * as Shared__Logo from "./logo.jsx";
import * as SimpleIcons from "../simpleIcons/simpleIcons.jsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = FooterModuleCss;

function Footer(Props) {
  return JsxRuntime.jsxs(Shared__Container.make, {
    children: [
      JsxRuntime.jsx("hr", {
        className: css.hr
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs(ReactRouter.Link, Router__Link.makeProps(undefined, [
            JsxRuntime.jsx(Shared__Logo.make, {
              className: css.logo
            }),
            "Violette"
          ], css.logoWrapper, undefined, undefined, undefined, undefined, "/", undefined)),
          JsxRuntime.jsxs("address", {
            children: [
              JsxRuntime.jsx("a", {
                children: "Copyright © 2025",
                href: "https://github.com/faergeek/violette/blob/main/LICENSE",
                rel: "noopener",
                target: "_blank"
              }),
              JsxRuntime.jsx("span", {
                children: " • ",
                "aria-hidden": true,
                className: css.dot
              }),
              JsxRuntime.jsx("span", {
                children: JsxRuntime.jsx("a", {
                  children: "Sergei Slipchenko",
                  href: "https://github.com/faergeek",
                  rel: "noopener",
                  target: "_blank"
                })
              })
            ],
            className: css.address
          }),
          JsxRuntime.jsxs("a", {
            children: [
              "GitHub ",
              JsxRuntime.jsx(ReactSimpleIcons.SiGithub, Curry._3(SimpleIcons.Github.makeProps, undefined, css.logo, undefined))
            ],
            className: css.logoWrapper,
            href: "https://github.com/faergeek/violette",
            rel: "noopener",
            target: "_blank"
          })
        ],
        className: css.content
      })
    ],
    className: css.root
  });
}

const make = Footer;

export {
  make,
}
/* css Not a pure module */
